import {Link} from 'react-router-dom';
import React/*, {useState}*/ from 'react';
import {UserContext} from '../utils/usercontext';
import {useracc, postApi, putApi} from '../utils/functions';
import EventEmitter from '../utils/emmiter';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './components/fontawesome/fontawesome';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import FormControl from 'react-bootstrap/FormControl';

export default class Register extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {
			status: -1,
			process: false,
			username: {
				text: '',
				valid: false,
				error: '',
			},
			password: {
				text: '',
				valid: false,
				error: '',
				visible: false,
			},
			email: {
				text: '',
				valid: false,
				error: '',
			},
		};
		this.handleChange = this.handleChange.bind(this);
		this.showPassword = this.showPassword.bind(this);
		this.processRegister = this.processRegister.bind(this);
  };
  
  async componentDidMount() {
		document.title = "Mix365 Radio - your music station streaming 24/7";
		const value = this.context;
		const getUser = await useracc();
		value.setUser( getUser );
		EventEmitter.emit('/client', {data: 'no value'});


		if( window.location.pathname.search(/register\//i) >= 0 ) {
			//---- Found a key and try to enter it
			let code = window.location.pathname.replace('/register/','');
			var params2 = new URLSearchParams();
			params2.append('code', code);
			//const x = 
			await putApi('/api/v2/register/verify', params2);
		}

		var params = new URLSearchParams();
		const x = await postApi('/api/v2/register', params);
		let email = this.state.email;
		email.text = x.data.email;
		
		if( x.data.email.length > 0 ) {
			this.setState({status: x.data.status, email});
		} else {
			this.setState({status: x.data.status});
		}
	}

	componentWillUnmount() {
	}


	handleChange(event) {
		var item = event.target.value;
		if( event.target.name === "username" ) {
			let username = this.state.username;
			const word = /^[A-Z0-9_]*$/i;
			username.text = item.replaceAll(" ","");
      if( word.test(String(item)) ) this.setState({username});
		}
		if( event.target.name === "email" ) {
			const res = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			let email = this.state.email;
			email.text = item.toLowerCase();
			email.valid = res.test(String(item));
			if( !email.valid ) {
				email.error = '* Please entere a valid email address';
			} else {
				email.error = ''
			}
      this.setState({email});
		}
		if( event.target.name === "password" ) {
			const decimal = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,40}$/;
			let password = this.state.password;
			password.text = item;
			password.valid = decimal.test(String(item));
			if( !password.valid ) {
				password.error = '* Capital letter, Number and a Special character required';
			} else {
				password.error = ''
			}
			if(item.length < 8 || item.length > 40 ) {
				password.valid = false;
				password.error = '* Must be between 8 and 40 characters';
			}
      this.setState({password});
		}
	}

	showPassword() {
		let password = this.state.password;
		password.visible = !password.visible;
		this.setState({password});
	}
	

	async processRegister(event) {
		event.preventDefault();
		this.setState({process: true}, async () => {
			await this.processRegister2(event);
			this.setState({process: false});
		});
	}
	async processRegister2(event) {
		event.preventDefault();
	

		const params = new URLSearchParams();
		params.append('username', this.state.username.text);
		params.append('email', this.state.email.text);
		params.append('password', this.state.password.text);
		//params.append('passwordrpt', this.state.passwordrpt);

		const x = await putApi('/api/v2/register', params);

		if( x.status !== 200 ) {
			//alert(x.response.data.Message);
			//if( parseInt( x.response.data.Error ) > 0 ) {
				switch( x.status ) {
					case 210:
						//password must something and password not match
						//this.setState({errpassword: x.data.message});
						break;
					case 3:
						
						break;
					case 211:
						//user set on site
						//this.setState({errusername: x.data.message});
						break;
					case 212:
						//email allready registered
						//this.setState({erremail: x.data.message});
						break;
					case 213:
						//email allready registered
						//this.setState({errpassword: x.data.message});
						break;
					default:
						break;

				}
				//this.setState({gusernamee: true, uploadwidth: "60%"});
			//}

			//---- disable buttons
			//this.setState({submit: false, preview: false, bookmark: false, reset: false});
			return;
		} else {
			/*EventEmitter.emit('/socket/reconnect', {data: 'no value'});
			try{
				this.props.history.push('/');
			} catch( error ) {
				window.location.href = '/mchat';
			}*/
			this.setState({status: x.data.status});
		}


	


	}

	render() {
		
		return (
			<>
				<div className="website-background"></div>
				<Container>
					<Row>
						<Col className="text-center pt-5">
							<img  src="/images/365_Logo.png" alt="Mix365 Logo" width="125" /> Welcome to Mix365 
						</Col>
					</Row>
					{this.state.status === 0 &&
						<Row>
							<Col>
								<Form className="pagelayer-contact-form" id="contact-form" onSubmit={this.processRegister}>
									<div className="pagelayer-contact-holder">

										<Row className="pt-3">
											<Col>
												Creating an account allows you to participate in chat and follow your favorite dj's.
											</Col>
										</Row>

										<Row className="pt-3">
											<Col>
												<label htmlFor="username">Username</label>
												<span className="float-right"><span style={{color:"#d71362", fontSize: 14, fontWeight: 600}}>{this.state.username.error}</span></span>
											</Col>
											<Col xs={12}>
												<FormControl name="username" id="username" onChange={this.handleChange} value={this.state.username.text} placeholder="Username" aria-label="Username" aria-describedby="Username" required />
											</Col>
										</Row>

										<Row className="pt-3">
											<Col>
												<label htmlFor="email">Email Address</label>
												<span className="float-right">
													{this.state.email.text.length > 0 &&
														<>
															{this.state.email.valid ?
																<span className="" style={{backgroundColor: '#008800', borderRadius: '50%', padding: '0px 4px 2px 4px', color: '#ffffff', fontSize: 12}}><FontAwesomeIcon icon="check" /></span>
															:
																<span style={{color:"#d71362", fontSize: 14, fontWeight: 600}}>
																	{this.state.email.error}
																</span>
															}
														</>
													}
												</span>
											</Col>
											<Col xs={12}>
												<FormControl name="email" id="email" onChange={this.handleChange} value={this.state.email.text} placeholder="Email Address" aria-label="Email Address" aria-describedby="Email Address" required />
											</Col>
										</Row>

										<Row className="pt-3">
											<Col>
											<label htmlFor="password">Password</label>
												<span className="float-right">
													{this.state.password.text.length > 0 &&
														<>
															{this.state.password.valid ?
																<span className="" style={{backgroundColor: '#008800', borderRadius: '50%', padding: '0px 4px 2px 4px', color: '#ffffff', fontSize: 12}}><FontAwesomeIcon icon="check" /></span>
															:
																<span style={{color:"#d71362", fontSize: 14, fontWeight: 600}}>
																	{this.state.password.error}
																</span>
															}
														</>
													}
												</span>
											</Col>
											<Col xs={12}>
												<InputGroup className="mb-2">
													<FormControl type={this.state.password.visible?'text':'password'} name="password" id="password" onChange={this.handleChange} value={this.state.password.text} placeholder="Password" aria-label="Password" aria-describedby="Password" required />
													<InputGroup.Text style={{background: 'rgba(144,144,144,0.07)', border: 'none', cursor: 'pointer'}} onClick={this.showPassword}>
														<FontAwesomeIcon icon="eye" />
													</InputGroup.Text>
												</InputGroup>
											</Col>
										</Row>

										<Row className="pt-2 pb-3">
											<Col>
												<Button size='sm' type="submit" disabled={this.state.process} form="contact-form">
													<i className="fa fa-circle-o-notch fa-spin" style={{display:'none',marginRight:'5px'}}></i>
													<span className="pagelayer-btn-text">Next Step</span>
												</Button>
											</Col>
											<Col className="text-center pt-1">
												Step 1 of 2
											</Col>
											<Col className="text-right pt-1">
												<Link to='/login'>Already have a mix365 account? Login</Link>
											</Col>
										</Row>
										
									</div>
								</Form>
							</Col>
						</Row>
					}
					{this.state.status === 1 &&
						<Row>
							<Col>
								
									<div className="pagelayer-contact-holder">

										<Row className="pt-3">
											<Col>
												Creating an account allows you to participate in chat and follow your favorite dj's.
											</Col>
										</Row>

										<Row className="pt-2 pb-3">
											<Col>
												Thank you for registering an account and to verify your account, please click on the activate account link that has been emailed to <b>{this.state.email.text}</b>
											</Col>
											
										</Row>
										
										<Row className="pt-2 pb-3">
											<Col>
												<Button size='sm' type="submit" disabled={true} form="contact-form">
													<i className="fa fa-circle-o-notch fa-spin" style={{display:'none',marginRight:'5px'}}></i>
													<span className="pagelayer-btn-text">Next Step</span>
												</Button>
											</Col>
											<Col className="text-center pt-1">
												Step 2 of 2
											</Col>
											<Col className="text-right pt-1">
												<Link to='/login'>Already have a mix365 account? Login</Link>
											</Col>
										</Row>
										
										
									</div>
								
							</Col>
						</Row>
					}
					{this.state.status === 2 &&
						<Row>
							<Col>
								
									<div className="pagelayer-contact-holder">

										<Row className="pt-3">
											<Col>
												Creating an account allows you to participate in chat and follow your favorite dj's.
											</Col>
										</Row>

										<Row className="pt-2 pb-3">
											<Col>
												Thank you for registering an account
											</Col>
											
										</Row>
										
										<Row className="pt-2 pb-3">
											<Col>
												<Link to='/'>
													<Button size='sm' type="submit"  form="contact-form">
														Continue to home
													</Button>
												</Link>
											</Col>
											<Col className="text-center pt-1">
												
											</Col>
											<Col className="text-right pt-1">
												
											</Col>
										</Row>
										
										
									</div>
								
							</Col>
						</Row>
					}
				</Container>
			</>
		);
	}
}
